// import swal from 'sweetalert2'
import Vue from 'vue'
import axios from 'axios'

const LDAPApi = {
  checkLogin: function (username, password, fnSuccess, fnError) {
    let reqData = {
      username: username,
      password: password
    }
    let url = Vue.prototype.$config.HOST_ONLINE + '/api/v1/ldap/login'
    axios({
      method: 'post',
      data: reqData,
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      })
      .catch(error => {
        console.log(error.response)
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error.response)
        } else {
          Vue.prototype.$eventHub.$emit('errorDlg', error.response)
        }
      })
  },
  filterAttribute: function (name, value, fnSuccess, fnError) {
    let reqData = {
      attribute: name,
      value: value
    }
    let url = Vue.prototype.$config.HOST_ONLINE + '/api/v1/ldap/search'
    axios({
      method: 'post',
      data: reqData,
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      })
      .catch(error => {
        console.log(error.response)
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error.response)
        } else {
          Vue.prototype.$eventHub.$emit('errorDlg', error.response)
        }
      })
  }
}
export default LDAPApi



// WEBPACK FOOTER //
// ./src/apiLDAP.js